import React, { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";
import { useDispatch } from "react-redux";
import { toast } from "react-toastify";
import FormDrawer from "src/components/Form/FormDrawer";
import { useAppSelector } from "src/store";
import { updateReminderSubjectSaga } from "src/store/reminder-subjects/saga";
import { ReminderSubjectDetailDto } from "src/store/reminder-subjects/type";
import { getModuleTypes } from "src/store/system/saga";
import { ModuleTypeDto } from "src/store/system/type";
import * as Yup from "yup";

const ReminderSubjectEditForm = ({
  data,
  onHide,
  open,
  onSuccessClick,
}: {
  data: ReminderSubjectDetailDto;
  onSuccessClick: (message: string) => void;
  onHide: () => void;
  open: boolean;
}) => {
  const dispatch = useDispatch();
  const { t } = useTranslation();
  const languages = useAppSelector((s) => s.language.languages);
  const [moduletypes, setModuleTypes] = useState<ModuleTypeDto[]>([]);
  useEffect(() => {
    open &&
      dispatch(
        getModuleTypes({
          payload: {
            onSuccess: (_m, payload) => setModuleTypes(payload),
            onError: () => {},
          },
        })
      );
  }, [dispatch, open]);

  return (
    <FormDrawer
      drawerProps={{
        isOpen: open,
        onHide: onHide,
        title: t("ReminderSubject.EditFormTitle").toString(),
      }}
      onHide={onHide}
      loader
      initialValues={{
        Id: data.Id,
        ModuleTypeId: data.ModuleTypeId,
        Name: data.Name,
        Translates: languages.map((l) => {
          const tr = (data.Translates || []).find(
            (x) => x.LanguageId === l.EnumId
          );
          return { LanguageId: l.EnumId, Name: tr ? tr.Name || "" : "" };
        }),
      }}
      validationSchema={Yup.object().shape({
        Name: Yup.string().required(t("Validation.Required").toString()),
        ModuleTypeId: Yup.number().required(t("Validation.Required").toString()),
        Translates: Yup.array(
          Yup.object({
            Name: Yup.string().required(t("Validation.Required").toString()),
          })
        ),
      })}
      multilanguageinputs={[
        { field: "Name", label: t("ReminderSubject.Name").toString() },
      ]}
      inputs={[
        {
          field: "ModuleTypeId",
          label: t("ReminderSubject.ModuleType").toString(),
          type: "select",
          lookup: { labelKey: "Name", valueKey: "EnumId", options: moduletypes },
        },
      ]}
      onSubmit={(values) => {
        dispatch(
          updateReminderSubjectSaga({
            payload: {
              onSuccess: (message) => {
                onHide();
                onSuccessClick(message);
              },
              onError: (message) => toast.error(message, { theme: "colored" }),
            },
            id: data.Id,
            body: values,
          })
        );
      }}
    />
  );
};
export default ReminderSubjectEditForm;
